import { videoApi2 } from '@/public/utils/basePath';
import { cryptoInstance } from '@/public/fetch';
/**
 * @params
 * labelId 亚专业标签 number
 * pageNo
 * pageSize
 * labelId
 * */
const baseURL = videoApi2;
export const getPBLList = ({ params, query }) => {
    return cryptoInstance.get(`/v5/pbl/list/${params.userId}`, {
        baseURL: videoApi2,
        params: query
    });
};
/**
 * @params
 * moduleType 公开课：open，大师课：vip，名医主刀：anatomy，案例课：case
 * userId
 * @query
 * pageNo
 * pageSize
 * labelId 亚专业Id、moduleId 、病种ID
 * labelType
 */
// labelType root--亚专业   node -- 知识元
export const getAlbumList = ({ params, query }) => {
    return cryptoInstance.get(`/v5/album/list/${params.moduleType}/${params.userId}`, {
        baseURL: videoApi2,
        params: query
    });
};
// 视频MD5解密
export const getVideoUrl = ({ params }) => {
    return cryptoInstance.get(`/video/dispatch/live/${params.videoId}/2`, {
        baseURL: videoApi2
    });
};
// 新大师课会议列表
export const getNewCourse = ({ params, query }) => {
    return cryptoInstance.get(`/v5/newCourse/album/meetingList/${params.albumId}`, {
        baseURL: videoApi2,
        params: query
    });
};
// 获取课程售前详情
export const getCourseGuide = (type, id, params) => {
    return cryptoInstance.get(`/v8/${type}/detail/${id}`, {
        baseURL,
        params
    });
};
//     | 'album'| 'meeting'| 'mall'| 'exercise'| 'article'| 'calendar_knowledge',
// 载体推荐 课程、文章、商品推荐 album:专辑，meeting:会议，mall:商城，exercise：病例练习，article：文章，calendar_knowledge：日历知识点
export const getCarrRecommend = (carrierDetailType, carrierId, userId) => {
    return cryptoInstance.get(`/v8/recommend/${carrierDetailType}/${carrierId}/${userId}`, { baseURL });
};
// 判断用户是否有权限看课程
export const getCoursePermission = (courseId, params) => {
    return cryptoInstance.get(`/v8/course/permission/${courseId}`, {
        baseURL,
        params
    });
};
// 创建专辑订单
export const createAlbumOrder = (params) => {
    return cryptoInstance.get(`/video/order/create`, { params, baseURL });
};
// 视频订单详情
export const getAlbumOrder = (userId, orderId) => {
    return cryptoInstance.get(`/video/order/get/${userId}/${orderId}`, {
        baseURL
    });
};
